import React from 'react';
import styled from 'styled-components';
import { FiMessageCircle, FiMail } from 'react-icons/fi';
import { Colors } from '../utils/colors';

const Wrap = styled.section`
  width: 100%;
  background-image: url('imageSection8.webp');
  background-size: cover;
  background-position: center;
  position: relative;

  &::before {
    content: '';
    position: absolute;
    inset: 0;
    background: rgba(8,8,8,0.82);
  }
`;

const Inner = styled.div`
  position: relative;
  z-index: 1;
  max-width: 700px;
  margin: 0 auto;
  padding: 80px 24px;
  text-align: center;
`;

const Label = styled.p`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  color: ${Colors.yellow};
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 2px;
  text-transform: uppercase;
  margin: 0 0 12px;
`;

const Title = styled.h2`
  color: #fff;
  font-size: clamp(1.6rem, 3vw, 2.2rem);
  font-weight: 800;
  margin: 0 0 10px;
`;

const Slogan = styled.p`
  color: rgba(255,255,255,0.45);
  font-style: italic;
  font-size: 0.95rem;
  margin: 0 0 40px;
`;

const Links = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 14px;
  margin-bottom: 32px;
`;

const ContactLink = styled.a`
  display: flex;
  align-items: center;
  gap: 12px;
  width: 100%;
  max-width: 380px;
  padding: 14px 20px;
  border: 1px solid rgba(255,215,0,0.2);
  border-radius: 10px;
  background: rgba(255,255,255,0.03);
  color: #fff;
  text-decoration: none;
  font-size: 0.93rem;
  transition: border-color 0.2s, background 0.2s;

  .ico { font-size: 18px; }
  span { flex: 1; text-align: left; }

  &:hover {
    border-color: rgba(255,215,0,0.5);
    background: rgba(255,215,0,0.05);
    color: ${Colors.yellow};
  }
`;

const SocialRow = styled.div`
  display: flex;
  justify-content: center;
  gap: 16px;
`;

const SocialBtn = styled.a`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
  border-radius: 10px;
  border: 1px solid rgba(255,215,0,0.2);
  background: rgba(255,255,255,0.03);
  transition: border-color 0.2s, background 0.2s;

  img {
    width: 24px;
    height: 24px;
    object-fit: contain;
  }

  &:hover {
    border-color: rgba(255,215,0,0.5);
    background: rgba(255,215,0,0.07);
  }
`;

const Section = () => (
  <Wrap>
    <Inner>
      <Label><FiMessageCircle size={13} /> Fale conosco</Label>
      <Title>Contato</Title>
      <Slogan>"A serviço do povo de Deus"</Slogan>

      <Links>
        <ContactLink href="mailto:contato@violaocatolico.com">
          <FiMail className="ico" />
          <span>contato@violaocatolico.com</span>
          <span style={{ color: 'rgba(255,255,255,0.3)', fontSize: '1rem' }}>›</span>
        </ContactLink>
      </Links>

      <SocialRow>
        <SocialBtn href="https://www.youtube.com/violaocatolico" target="_blank" rel="noreferrer" title="YouTube">
          <img src="youtube.png" alt="YouTube" />
        </SocialBtn>
        <SocialBtn href="https://www.instagram.com/cifracatolicas/" target="_blank" rel="noreferrer" title="Instagram">
          <img src="instagram.png" alt="Instagram" />
        </SocialBtn>
        <SocialBtn href="https://www.tiktok.com/@cantate.app" target="_blank" rel="noreferrer" title="TikTok">
          <img src="tiktok.png" alt="TikTok" />
        </SocialBtn>
      </SocialRow>
    </Inner>
  </Wrap>
);

export default Section;
